import {
  CreateButton,
  Datagrid,
  Filter,
  sanitizeListRestProps,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
} from "react-admin";
import { IResourceListProps } from "../../common/ra-types";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { FolderSpecial } from "@material-ui/icons";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";

interface Props extends IResourceListProps {}

const ListFilter = (props: any) => {
  const { loading } = useListContext();
  useSearchFields(props, ["name"]);
  return (
    <Filter {...props}>
      {!loading && (
        <TextInput
          className="fleet-managers-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
          autoFocus
          autoComplete="off"
        />
      )}
      {loading && (
        <TextInput
          className="fleet-managers-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
        />
      )}
    </Filter>
  );
};

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { basePath } = useListContext();

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

export const VirtualTenantsList = (props: Props) => {
  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={FolderSpecial} />}
        className="content-list"
        title="Virtual Customers"
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        sort={{ field: "name", order: "ASC" }}
        {...props}
      >
        <Datagrid>
          <TextField label="Name" source="name" />
          <TextField label="Selected vehicles count" source="vehiclesCount" />
          <TextField label="Selected drivers count" source="driversCount" />
          <ActionsField
            hasShow={false}
            editable={(x) => true}
            canActivateOrDeactivate={() => false}
          >
            <DeleteRecordMenuItem />
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
